// Code generated by gobeyond build; DO NOT EDIT.
import { type ComponentType } from 'react'
import Page from "../../app/sign-in/page.js"
import Layout0 from "../../app/layout.js"

export const page = Page as ComponentType<any>
export const layouts = [Layout0 as ComponentType<any>] as const
export default Page
